export default "__VITE_ASSET__1JifmCHl__"